import { AfterViewInit, Component, ElementRef,OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, ParamMap,Router} from '@angular/router';
import { LeadTypeClass } from 'src/app/model/LeadType';
import { SharedService } from 'src/app/services/shared.service';
import { getParamsType } from 'src/app/model/getParamsType';
import { GoogleAnalyticsService } from '../DataLayer/google-analytics-service.service';
@Component({
    selector: 'app-organisation',
    templateUrl: './organisation.component.html',
    styleUrls: ['./organisation.component.scss'],
    standalone: false
})
export class OrganisationComponent implements OnInit,AfterViewInit {
  
  leadId: any;
  leadType: any;
  loading: boolean = false;
  action:any
  showPreviousbtn:boolean=true;
  nextBtnText:string='Next'
  clinicId:any;
  isWorkingWithMemberOfTeam : string="";
  workingWithTeamMembers:any;
  isValidWorkingWithTeamMembers:boolean=true;

  sizes = [
    {name: '1 - 100',value:'100'} ,             
    {name: '101 - 250',   value:'250'} ,
    {name: '251 - 500',value:'500'},
    {name: '500 +',   value:'501'} 
   ];
   aci_companysize = this.sizes[0].value;
  companyname: any;
  entityId: any;
  ariaLabelSelectedText: string;
  previuosButtonTabIndex: any = -1;
  AriaTextSubmitBtn:any 

  @ViewChild('dropDown') dropDown: ElementRef;
  constructor(private router: Router,private eRef: ElementRef,protected $gaService: GoogleAnalyticsService,private route: ActivatedRoute,public leadTypeClass: LeadTypeClass,public sharedService: SharedService) { 


  }

  onCloseMethod(event:any){
    this.dropDown.nativeElement.style.display = "none";
  }

  ngAfterViewInit(): void {
   
  }

  ngOnInit(): void {
    this.ariaLabelSelectedText = "Your Organization size - selected " ;
    this.route.paramMap.subscribe((params: ParamMap) => {
      this.leadId = params.get('id');
      this.leadType = params.get('leadType');
      this.action=params.get('action');
      this.clinicId=params.get('gid');
      if(this.action=='RE'||this.action=='CE'){
        this.showPreviousbtn=false;
        this.nextBtnText="Back";
      }
      if (this.leadId && (this.leadType === 'update' || !this.leadType))
        this.getLeadDetails();
    });
    const device = this.$gaService.mobileOrLaptopdevice();
    if(device=="Mobile"){
      this.AriaTextSubmitBtn=this.nextBtnText=="Next" ? "Next button double tap to activate the ": "Back button double tap to activate the "
    }
    else{
      this.AriaTextSubmitBtn =this.nextBtnText;
    }
  }

  onWorkingWithTeamMembersClick(value:boolean){
    if(value)
    {
      this.isWorkingWithMemberOfTeam = "yes";
    }
    else
    {
      this.isWorkingWithMemberOfTeam = "no";
    }
    
    if(!value)
    {
      this.workingWithTeamMembers='';
      this.isValidWorkingWithTeamMembers=true;
    }
  }

  CheckIfValidWorkingWithTeamMembers(event: any)
  {
    let pattern=/^[A-Za-z\s-']+$/;

    if(this.workingWithTeamMembers.trim() != '')
    {
      this.isValidWorkingWithTeamMembers = pattern.test(this.workingWithTeamMembers)  ? true : false ;
    }
    else{
      this.isValidWorkingWithTeamMembers=true;
    }
     
  }

  onOrganisationFormSubmit(form: NgForm) {
    this.updateLead(form.value);
    
  }

  onPreviousClick() {
    this.sharedService.previousStep=true;

     if(this.action == 'singleclinic' || this.action == 'noclinic')
      {    
        this.router.navigate(['/contact', { id: this.leadId,gid:this.clinicId , action:this.action}])
      }
      else{
        this.router.navigate(['/contact', { id: this.leadId }]);
      }
    

  }

  getLeadDetails() {
    const url: string = `groupclinic/getClinicLead`;
    const getParams: getParamsType = {
      entityName: 'lead',
      entityId: this.leadId,
      columns:
        'companyname,emailaddress1,lastname,mobilephone,firstname,aci_companysize,aci_workingwithteam,aci_workingwithteammember',
    };
    this.loading = true;
    this.sharedService.postRequest(url, getParams).subscribe(
      (response) => {
        let spouse;
        let children;
        if (response != null) {      

          this.companyname = response.companyname;

          if(response.aci_workingwithteam=="805170000")
          {
            this.isWorkingWithMemberOfTeam="yes"
          }
          else if(response.aci_workingwithteam=="805170001")
          {
            this.isWorkingWithMemberOfTeam="no"
          }

          this.workingWithTeamMembers=response.aci_workingwithteammember;
          if(response.aci_companysize){
            if(response.aci_companysize=='100')
            {
              this.aci_companysize = this.sizes[0].value;
            }
            if(response.aci_companysize=='250')
            {
              this.aci_companysize = this.sizes[1].value;
            }
            if(response.aci_companysize=='500')
            {
              this.aci_companysize = this.sizes[2].value;
            }
            if(response.aci_companysize>='501')
            {
              this.aci_companysize = this.sizes[3].value;
            }             
          }
        }
        this.loading = false;
      },
      (errorResponse) => {
        this.loading = false;
        console.log(errorResponse);
      }
    );
  }

 

  updateLead(formvalue : any) {
  
    this.loading = true;

    const url = 'groupclinic/UpdateClinicLead';

    let submitObj = JSON.parse(JSON.stringify(formvalue));
    submitObj['entityId'] = this.leadId;

   
    if (submitObj.aci_workingwithteam == 'Yes' || this.isWorkingWithMemberOfTeam=='yes') {
      submitObj.aci_workingwithteam = 805170000;
    }
    else if (submitObj.aci_workingwithteam == 'No' || this.isWorkingWithMemberOfTeam=='no') 
    {
      submitObj.aci_workingwithteam = 805170001;
    }
    else
    {
      submitObj.aci_workingwithteam=null;

    }

    Object.assign(this.leadTypeClass.contactInformationParams, formvalue);
    this.sharedService.postRequest(url, submitObj).subscribe(res => {
      
      if(this.action=='RE'||this.action=='CE'){
        this.router.navigate(['/review-details', { id: this.leadId, action:this.action,gid:this.clinicId }])
      }
      else if(this.action == 'singleclinic' || this.action == 'noclinic')
      {
       
        this.router.navigate(['/services', { id: this.leadId,gid:this.clinicId , action:this.action}])
      }
      else{
        this.router.navigate(['/services', { id: this.leadId }]);
      }
      this.loading = false;
    }, errorResponse => {
      this.loading = false;
     });
    
  }
  onNextButtonFocus(){
    this.previuosButtonTabIndex = 0;
  }
  onPreviousButtonFocus(){
    this.previuosButtonTabIndex = -1;
  }
}
